import React, { useContext } from 'react';
import Button from 'react-bootstrap/Button';

import { NCRContext } from 'views';
import { UserContext } from 'components/routing';
import { useLocation } from 'react-router-dom';

const CreateReturnSandbox = () => {
  const { state } = useContext(NCRContext);
  const { user } = useContext(UserContext);

  const location = useLocation();

  const href = location.pathname.includes('/return')
    ? `/api/return/${state.ncr.id}/return_sandbox`
    : `/api/ncr/${state.ncr.id}/return_sandbox`;

  const visible =
    ['GM'].includes(user.role) &&
    state.ncr.status.id === 8 &&
    // Only show when hostname DOES have "-staging" in it (i.e. only show on staging app)
    // OR if NODE_ENV is "test"
    (window.location.hostname.includes('-staging') ||
      process.env.NODE_ENV === 'test');

  return (
    visible && (
      <Button className="import-netsuite" variant="success" href={href}>
        Create Return Order in Sandbox
      </Button>
    )
  );
};

export { CreateReturnSandbox };
